import React, {Component} from 'react';
import xImage from '../assets/images/x-asset.svg';
import checkImage from '../assets/images/checkmark-asset.svg';
import ReactGA from 'react-ga';

var countdown;

export default class QuizQuestion extends Component {

    constructor() {
        super();

        this.state = {
            currentTime: 20,
            selectedIndex: -1,
            checkIndex: -1,
            xIndex: -1
        };
    }

    componentWillMount() {
        this.resetClock();
        this.props.setResetClockFunction(this.resetClock.bind(this));
    }

    checkAnswer(index) {
        clearInterval(countdown);
        this.props.displayResponse();

        document.getElementById("mediaCheck:"+this.props.question.correctIndex).style.display = "block";
        this.setState({
            checkIndex: this.props.question.correctIndex
        });

        if(index !== this.props.question.correctIndex && index !== -1) {
            document.getElementById("mediaX:"+index).style.display = "block";
            this.setState({
                xIndex: index
            });
            ReactGA.event({
                category: "quiz",
                action: "Choose incorrect answer",
                label: ""+this.props.questionIndex,
                value: this.props.songId,
            });
            if (this.props.isReplay){
                ReactGA.event({
                    category: "quiz repeat",
                    action: "Choose incorrect answer",
                    label: ""+this.props.questionIndex,
                    value: this.props.songId,
                });
            }
        } 
        else{
            ReactGA.event({
                category: "quiz",
                action: "Choose correct answer",
                label: ""+this.props.questionIndex,
                value: this.props.songId,
            }); 
            if (this.props.isReplay){
                ReactGA.event({
                    category: "quiz repeat",
                    action: "Choose correct answer",
                    label: ""+this.props.questionIndex,
                    value: this.props.songId,
                }); 
            }
        }
    }

    resetChecksAndXs() {
        this.props.question.answers.forEach((answer, index) => {
            document.getElementById("mediaX:"+index).style.display = "none";
            document.getElementById("mediaCheck:"+index).style.display = "none";
        });
    }

    resetClock() {
        this.setState({
            currentTime: 20,
            questionAnswered: false,
            selectedIndex: -1,
            checkIndex: -1,
            xIndex: -1
        }, () => {
            this.resetChecksAndXs();
            countdown = setInterval(() => {
                this.setState({
                    currentTime: this.state.currentTime - 1
                }, () => {
                    if(this.state.currentTime <= 0) {
                        clearInterval(countdown);
                        this.checkAnswer(-1);
                        ReactGA.event({
                            category: "quiz",
                            action: "Time Out",
                            label:""+this.props.questionIndex,
                            value: this.props.songId,
                        });
                        if (this.props.isReplay){
                            ReactGA.event({
                                category: "quiz repeat",
                                action: "Time Out",
                                label:""+this.props.questionIndex,
                                value: this.props.songId,
                            }); 
                        }
                    }
                });
            }, 1000);
        });
    }

    render() {

        return (
            <div className='quiz'>
                
                <h2 className="quiz-question">{this.props.question.question}</h2>
                <ul className="quiz-answers">
                    {
                        this.props.question.answers.map((answer, index) => {
                            return <li className={
                                           (this.props.responseIsDisplayed ? "quiz-answers-grayed-out" : "")+
                                           (this.state.selectedIndex === index ? " quiz-answers-selected" : "")+
                                           (this.state.checkIndex === index || this.state.xIndex === index ? " quiz-check-x" : "")
                                        }
                                       key={index}
                                       onClick={(e) => {
                                           if(this.state.selectedIndex === -1 && this.state.currentTime !== 0) {
                                               this.checkAnswer(index);
                                               this.setState({
                                                   selectedIndex: index
                                               });
                                           }
                                       }}

                                    >
                                        <img className="check-x" id={"mediaX:"+index} src={xImage}/>
                                        <img className="check-x" id={"mediaCheck:"+index} src={checkImage}/>
                                       <p> {answer} </p>
                                    </li>
                        })
                    }
                </ul>
                <div className='timer'>
                        <h2>{this.props.currentQuestion+1}/ {this.props.questionCount}</h2>
                        <h1 className='time-left'> {this.state.currentTime}</h1>
                        <h2 className='time-remaining'>Time Remaining</h2>
                </div>
               
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/QuizQuestion.js